<template>
  <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="blue darken-2" dark>
    <v-app-bar-nav-icon @click.stop="toggleNavigation"></v-app-bar-nav-icon>
    <span>
      <v-icon class="visible-xxs mx-3" large @click="goToHome">mdi-layers-search-outline</v-icon>

      <v-toolbar-title class="hidden-xxs"
          style="width: 190px; cursor: pointer; padding-top: 5px; padding-bottom: 5px; display: inline;"
          @click="goToHome">
        <v-icon class="mx-3" large @click="goToHome">mdi-layers-search-outline</v-icon>
        Check Position
      </v-toolbar-title>
    </span>

    <v-spacer></v-spacer>

    <app-bar-notifications></app-bar-notifications>
    <app-bar-menu></app-bar-menu>

    <v-progress-linear :active="loading" indeterminate absolute bottom color="white">
    </v-progress-linear>
  </v-app-bar>
</template>

<script>
import AppBarMenu from './AppBar/AppBarMenu'
import AppBarNotifications from './AppBar/AppBarNotifications'

export default {
  name: 'AppBar',
  components: { AppBarNotifications, AppBarMenu },
  props: ['loading'],
  methods: {
    toggleNavigation () {
      this.$ui.navigation.visible = !this.$ui.navigation.visible
    },
    goToHome () {
      this.$router.push('/position-monitoring')
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 400px) {
  .hidden-extra-small {
    display: none !important;
  }
}

@media screen and (min-width: 400px) {
  .visible-extra-small {
    display: none !important;
  }
}
</style>